__turbopack_context__.v({
  "modal": "yqqtaq_modal",
});
